"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitializedState = void 0;
const use_async_value_1 = require("./use-async-value");
const react_1 = require("react");
const useInitializedState = (init) => {
    const [value, setValue] = react_1.useState(null);
    const [initialValue, loading, error] = use_async_value_1.useAsyncValue(init);
    react_1.useEffect(() => {
        if (value === null && loading === false) {
            setValue(initialValue);
        }
    }, [loading]);
    return [value, setValue, loading, error];
};
exports.useInitializedState = useInitializedState;
//# sourceMappingURL=use-initialized-state.js.map